import { waitForAllReturnWhenError, query } from '@confluence/query-preloader-tools';

import { NTH_USER_AUTO_FOLLOW_SPACES } from '../../constants/onboarding-state/onboarding-constants';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql';
import { preloadFeatureDiscovery } from './preloadFeatureDiscovery';

export const preloadAutoFollowSpacesState = () => {
	return waitForAllReturnWhenError([
		query({
			query: getOnboardingStateGQL,
			variables: {
				key: [NTH_USER_AUTO_FOLLOW_SPACES.HAS_AUTO_FOLLOWED_SPACES],
			},
		}),
		preloadFeatureDiscovery(),
	]);
};
